import jsPDF from 'jspdf';

export const generateCertificatePDF = async (userName, courseTitle, userCedula = '') => {
    if (!userName) return;

    const loadImage = (src) => new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.src = src;
    });

    // Template original: 1024x768. Generamos en horizontal para que no se “alargue”.
    const pageWidth = 1024;
    const pageHeight = 768;
    const doc = new jsPDF({ unit: 'px', format: [pageWidth, pageHeight], orientation: 'landscape' });

    // Fondo del template (PNG o JPG). El formato en addImage debe coincidir con el archivo.
    const BG_SRC = '/img/certificado_fondo_aprobado.jpg';
    const bgImageFormat = /\.png$/i.test(BG_SRC) ? 'PNG' : 'JPEG';

    try {
        const bg = await loadImage(BG_SRC);
        doc.addImage(bg, bgImageFormat, 0, 0, pageWidth, pageHeight);
    } catch (e) {
        doc.setFillColor(255, 255, 255);
        doc.rect(0, 0, pageWidth, pageHeight, 'F');
    }

    const TEAL = [0, 91, 151];
    const GRAY = [150, 150, 150];

    // Nota: antes limpiábamos zonas del fondo con rectángulos blancos, pero eso
    // genera un "cuadro" visible. Dejamos el PNG tal cual y sólo renderizamos texto.

    // Curso (mayúsculas, centrado)
    const safeCourseTitle = (courseTitle || '').toString().trim();
    const courseTitleUpper = safeCourseTitle ? safeCourseTitle.toUpperCase() : 'CURSO';
    doc.setTextColor(...TEAL);
    doc.setFont('helvetica', 'bold');
    const courseStartY = 315;
    const OFFSET_X = -35; // desplaza el bloque de texto un poco hacia la izquierda
    const COURSE_BOX_WIDTH = 650; // ancho máximo para no invadir la zona azul
    const MAX_COURSE_LINES = 3;

    let courseFontSize = 64;
    let courseLines = [];

    while (courseFontSize >= 40) {
        doc.setFontSize(courseFontSize);
        courseLines = doc.splitTextToSize(courseTitleUpper, COURSE_BOX_WIDTH);
        const maxLineWidth = courseLines.reduce((acc, line) => Math.max(acc, doc.getTextWidth(line)), 0);

        if (courseLines.length <= MAX_COURSE_LINES && maxLineWidth <= COURSE_BOX_WIDTH) {
            break;
        }
        courseFontSize -= 2;
    }

    const courseLineHeight = courseFontSize * 1.18;
    courseLines.slice(0, MAX_COURSE_LINES).forEach((line, idx) => {
        doc.text(line, pageWidth / 2 + OFFSET_X, courseStartY + idx * courseLineHeight, { align: 'center' });
    });

    // Nombre (cursiva)
    const safeName = userName.toString().trim();
    doc.setTextColor(0, 0, 0);
    doc.setFont('helvetica', 'italic');
    let nameFontSize = 52;
    doc.setFontSize(nameFontSize);
    while (doc.getTextWidth(safeName) > 760 && nameFontSize > 34) {
        nameFontSize -= 2;
        doc.setFontSize(nameFontSize);
    }
    const nameY = 540;
    doc.text(safeName, pageWidth / 2 + OFFSET_X, nameY, { align: 'center' });

    // Línea debajo del nombre
    const lineY = nameY + 32;
    doc.setDrawColor(160, 160, 160);
    doc.setLineWidth(2);
    doc.line(pageWidth / 2 - 290 + OFFSET_X, lineY, pageWidth / 2 + 290 + OFFSET_X, lineY);

    // Cédula
    const safeCedula = (userCedula || '').toString().trim();
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(26);
    doc.setTextColor(...GRAY);
    doc.text(`C.C ${safeCedula ? safeCedula : 'XXXXXXXXXXX'}`, pageWidth / 2 + OFFSET_X, lineY + 45, { align: 'center' });

    // Fecha: "5 noviembre 2025"
    const today = new Date();
    const months = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
    const day = today.getDate();
    const month = months[today.getMonth()];
    const year = today.getFullYear();
    const dateString = `${day} ${month} ${year}`;
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(28);
    doc.setTextColor(...GRAY);
    // Fecha justo debajo de la C.C
    const dateY = lineY + 120;
    doc.text(dateString, pageWidth / 2 + OFFSET_X, dateY, { align: 'center' });

    // Guardar el PDF
    const fileName = `Certificado_${safeName.replace(/\s+/g, '_')}_${Date.now()}.pdf`;
    doc.save(fileName);
};
